import { Global, css } from "@emotion/react"
import { Fragment } from "react"
import "react-toastify/dist/ReactToastify.minimal.css"

import { Trans } from "@trueskin-web/translations"

const ErrorToast = () => (
  <Fragment>
    <Global
      styles={css`
        #error-toast {
          margin: 16px;
          padding: 10px;
          color: hsla(30, 32%, 9%, 1);
          background: hsla(344, 69%, 97%, 1);
          border-radius: 8px;
          box-shadow: 2px 2px 20px 0px rgba(0, 0, 0, 0.08);
          .Toastify__toast-icon {
            margin-inline-end: 8px;
            width: 24px;
          }
          .Toastify__close-button {
            align-self: initial;
            opacity: 1;
          }
        }
      `}
    />
    <div
      sx={{
        fontSize: 1,
        fontWeight: "bold",
        lineHeight: 1.5,
      }}
    >
      <Trans i18nKey="Start.Shipping.errorMessage">
        <div sx={{ color: "hsla(0, 0%, 55%, 1)" }} />
      </Trans>
    </div>
  </Fragment>
)

export default ErrorToast
